import React from "react";
import { Spin } from "antd";
const CountSpinner = () => <Spin/>;
export default CountSpinner;
